/**
 * Enum representing validation layers
 * - schema: Column/field level validation (missing columns, wrong types)
 * - intra: Row-level validation (business rules within a single row)
 * - inter: Cross-row validation (relationships between rows)
 */
export enum ValidationLayer {
  SCHEMA = "schema",
  INTRA = "intra",
  INTER = "inter",
}

/**
 * Human-readable descriptions for validation layers
 */
export const VALIDATION_LAYER_LABELS: Record<ValidationLayer, string> = {
  [ValidationLayer.SCHEMA]: "Schema Validation",
  [ValidationLayer.INTRA]: "Intra-Dataset Validation",
  [ValidationLayer.INTER]: "Inter-Dataset Validation",
};

/**
 * Detailed descriptions for each validation layer
 */
export const VALIDATION_LAYER_DESCRIPTIONS: Record<ValidationLayer, string> = {
  [ValidationLayer.SCHEMA]:
    "Column/field level validation failed. Check for missing columns or wrong data types.",
  [ValidationLayer.INTRA]:
    "Row-level validation failed. Business rules within individual rows were violated.",
  [ValidationLayer.INTER]:
    "Cross-row validation failed. Relationships between rows are invalid.",
};

/**
 * Error type labels for display
 */
export enum ValidationErrorType {
  MISSING_CELL = "missing-cell",
  TYPE_ERROR = "type-error",
  CONSTRAINT_ERROR = "constraint-error",
}

export const VALIDATION_ERROR_TYPE_LABELS: Record<string, string> = {
  [ValidationErrorType.MISSING_CELL]: "Missing Value",
  [ValidationErrorType.TYPE_ERROR]: "Type Error",
  [ValidationErrorType.CONSTRAINT_ERROR]: "Constraint Error",
};
